import { joinLabeledValue } from './joinLabeledValue';

/** 一覧／選択出力で共通: aria=短名、title=選択の全文 */
export function sampleSelectLabels(
  displayName: string,
  t: (key: string, options?: { name?: string; defaultValue?: string }) => string
): { ariaLabel: string; title: string } {
  return {
    ariaLabel: displayName,
    title: t('sample.select_sample_title', {
      name: displayName,
      defaultValue: joinLabeledValue(t('sample.select_sample'), displayName),
    }),
  };
}
